import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { GoalTileStreaksComponent } from './tile-streaks.component';

@NgModule({
    imports: [CommonModule, InlineSVGModule, TranslateModule, NgbTooltipModule],
    declarations: [GoalTileStreaksComponent],
    exports: [GoalTileStreaksComponent],
})
export class GoalTileStreaksModule {}
